import { BaseEntity } from '../services/api/universal.service';

/**
 * Enum para funções de turno
 */

export enum ShiftFunction {
    PATROL = 'PATROL',
    SUPPORT = 'SUPPORT',

    GUARD = 'GUARD',
    SYSTEM_ADMIN = 'SYSTEM_ADMIN',
    ADMIN = 'ADMIN',
    HR = 'HR',
    SUPERVISOR = 'SUPERVISOR',
    POST_SUPERVISOR = 'POST_SUPERVISOR',
    POST_RESIDENT = 'POST_RESIDENT',
    DOORMAN = 'DOORMAN',
    JARDINER = 'JARDINER',
    MAINTENANCE_ASSISTANT = 'MAINTENANCE_ASSISTANT',
    MONITORING_OPERATOR = 'MONITORING_OPERATOR',
    ADMINISTRATIVE_ASSISTANT = 'ADMINISTRATIVE_ASSISTANT',
}

/**
 * Enum para status de turno
 */
export enum ShiftStatus {
    PENDING = 'PENDING', // Pendente
    IN_PROGRESS = 'IN_PROGRESS', // Em andamento
    BREAK = 'BREAK', // Intervalo
    COMPLETED = 'COMPLETED', // Concluído
    ABSENCE = 'ABSENCE', // Ausência
}

/**
 * Interface para resposta de turno
 */
export interface IShiftResponse extends BaseEntity {
    userId: string;
    companyId: string;
    postId: string;
    startTime: Date;
    endTime?: Date;
    breakStartTime?: Date;
    breakEndTime?: Date;
    function: ShiftFunction;
    status: ShiftStatus;
    isHidden?: boolean;

    // Relacionamentos (opcionais)
    user?: {
        id: string;
        name: string;
        email: string;
        rg: string;
    };
    company?: {
        id: string;
        name: string;
    };
    post?: {
        id: string;
        name: string;
        address: string;
    };
}

/**
 * Interface para criação de turno
 */
export interface ICreateShiftDto {
    postId: string | null;
    startTime: Date;
    function?: ShiftFunction;
    status?: ShiftStatus;
}

/**
 * Interface para atualização de turno
 */
export interface IUpdateShiftDto {
    endTime?: Date;
    breakStartTime?: Date;
    breakEndTime?: Date;
    function?: ShiftFunction;
    status?: ShiftStatus;
    isHidden?: boolean;
}

/**
 * Interface para filtros de turno
 */
export interface IShiftFilters {
    page?: number;
    limit?: number;
    search?: string;
    userId?: string;
    companyId?: string;
    postId?: string;
    function?: ShiftFunction;
    status?: ShiftStatus;
    startDate?: Date;
    endDate?: Date;
}

/**
 * Interface para resposta paginada de turnos
 */
export interface IShiftPaginationResponse {
    data: IShiftResponse[];
    pagination: {
        page: number;
        limit: number;
        total: number;
        totalPages: number;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
    };
}

/**
 * Interface para turno atual do usuário
 */
export interface ICurrentShift {
    id: string;
    startTime: Date;
    function: ShiftFunction;
    status: ShiftStatus;
    postId: string;
    postName: string;
    canStartBreak: boolean;
    canEndBreak: boolean;
    canEndShift: boolean;
}
